import { SETUP_GOALS, type SetupGoal } from "connected-components/optimize-experiments/constants"
import { CONSTRAINTS } from "modules/optimization-settings/selectors/constraints"

export interface SetupSection {
  goal: SetupGoal
  targetTotalRiskValue?: number
}

export interface RulesSection {
  maxTurnover: number | string
}

export interface FormSections {
  setup: SetupSection
  rules: RulesSection
}

const DEFAULT_SETUP: SetupSection = {
  goal: SETUP_GOALS.MAXIMIZE_SPECIFIC_RISK,
}

const DEFAULT_RULES: RulesSection = {
  maxTurnover: CONSTRAINTS.maxTurnover().defaultValue,
}

export const getDefaultConfiguration = (): FormSections => {
  return {
    setup: DEFAULT_SETUP,
    rules: DEFAULT_RULES,
  }
}
